import {useNavigate} from 'react-router-dom';
import {OnboardingLayout} from './OnboardingLayout';
import {Button} from '@/components';
import {useUserStore} from '@/store';
import styles from './Onboarding.module.css';

export function ComingSoon() {
  const navigate = useNavigate();
  const {completeOnboarding} = useUserStore();

  function handleSkip() {
    completeOnboarding();
    navigate('/closet');
  }

  return (
    <OnboardingLayout currentStep={3} totalSteps={4}>
      <h2 className={styles.stepTitle}>Coming soon</h2>
      <p className={styles.stepDescription}>
        Thanks for your interest! Today we can only perform our automated service
        with Gmail, but we'll record your need and keep you posted as we add other
        email providers. If you have a Gmail account, feel free to go back and set
        up that way.
      </p>
      <div className={styles.backBtnRow}>
        <Button onClick={() => navigate('/onboarding/connect-email')}>
          ← Back to email options
        </Button>
        <button className={styles.skipLink} onClick={handleSkip}>
          Skip for now
        </button>
      </div>
    </OnboardingLayout>
  );
}
